import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import * as Actions from '../actions/Forms.actions';
import Validations from '../constants/Validations';

const TextInput = ({
	type = 'text',
	id,
	placeholder,
	form,
	name,
	transform,
	value,
	errDisable = false,
	error,
	errorText,
	onFocus,
	validations,
	onInputLayoutRedux,
	onTextChangeRedux,
	hidden = false,
	rightSideIcon,
	mainIcon,
	onEnterKey,
}: ITextInputProps) => {
	useEffect(() => {
		if (!form) return;

		onInputLayoutRedux && onInputLayoutRedux({ form, name, value, validations });
	}, []);
	const handleKeyUp = e => {
		if (e.key === 'Enter' && onEnterKey) onEnterKey();
	};
	const onChangeText = (text: string) => {
		let text_x = text;
		if (transform === 'lower') {
			text_x = text.toLowerCase();
		} else if (transform === 'upper') {
			text_x = text.toUpperCase();
		}

		onTextChangeRedux &&
			onTextChangeRedux({
				form,
				name,
				text: text_x,
				validationErrors: [],
			});
	};

	const onBlur = () => {
		const validationErrors = Validations(validations, value);

		onTextChangeRedux &&
			onTextChangeRedux({
				form,
				name,
				text: value,
				validationErrors,
			});
	};

	return (
		<div className='input_div' style={hidden ? { display: 'none' } : {}}>
			{!errDisable && (
				<p
					className={`text_input_err_labal ${
						error || errorText ? 'element_visible' : ''
					}`}
				>
					{error || errorText}
				</p>
			)}
			{type == 'textarea' ? (
				<textarea
					className={`text_input ${error || errorText ? 'text_input_err' : ''}`}
					onFocus={onFocus}
					onBlur={onBlur}
					name={name}
					id={id}
					rows={4}
					cols={50}
					defaultValue={value}
					placeholder={placeholder}
					onChange={e => onChangeText(e.target.value)}
					onKeyUp={handleKeyUp}
				/>
			) : (
				<div
					className={
						error || errorText ? 'input-container text_input_err' : 'input-container'
					}
				>
					{mainIcon && <img src={mainIcon} className='main-icon' />}
					<input
						className='text_input'
						onFocus={onFocus}
						onBlur={onBlur}
						type={type}
						name={name}
						id={id}
						defaultValue={value}
						placeholder={placeholder}
						onChange={e => onChangeText(e.target.value)}
						onKeyUp={handleKeyUp}
					/>
					{rightSideIcon && <img src={rightSideIcon} className='right-side-icon' />}
				</div>
			)}
		</div>
	);
};

const mapStateToProps = ({ forms }, { form, name, value = '' }) => ({
	value:
		forms[form]?.values[name] === ''
			? ''
			: value !== ''
			? value
			: forms[form]?.values[name],
	error: (forms[form]?.errors[name] && forms[form]?.errors[name][0]) ?? '',
});

const mapDispatchToProps = {
	onInputLayoutRedux: ({ form, name, value, validations }) =>
		Actions.initForm({ form, field: name, fieldValue: value, validations }),

	onTextChangeRedux: ({ form, name, text, validationErrors }) =>
		Actions.addFormData({
			form,
			data: {
				values: { [name]: text },
				errors: { [name]: validationErrors },
			},
		}),
};

export default connect(mapStateToProps, mapDispatchToProps)(TextInput);

type ITextInputProps = {
	type?: string;
	id: string | undefined;
	placeholder: string | undefined;
	form: any;
	error: any;
	errorText?: any;
	name: string | undefined;
	value: string | number | readonly string[] | undefined;
	onFocus?: () => void;
	errDisable?: boolean;
	transform?: 'lower' | 'upper';
	validations: any;
	onInputLayoutRedux: any;
	onTextChangeRedux: any;
	hidden?: boolean;
	rightSideIcon?: any;
	mainIcon?: any;
	onEnterKey?: () => void;
};
